import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { stocksClient } from '../../../../utils/apollo/api'
import { useMultiSelectState } from '../../../../packages/kiti/components/multiSelect/MultiSelectHandler'

const MUTATION = gql`
  mutation RemoveStockItem($id: Int) {
    removeStockItem(id: $id)
  }
`

export const useRemoveStocks = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['StockItems', 'StockItemsCount'],
    client: stocksClient
  })
  const notify = useNotification()
  const modal = useAlert()
  const { clearSelection } = useMultiSelectState()
  const { t } = useTranslation('common')

  const handleRequest = id => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        clearSelection && clearSelection()
        notify.success({ title: t('removeSuccess') })
      } else if (!!resp.errors.find(error => error.message === 'user_has_available_amount')) {
        notify.error({ title: t('errors.cannotRemoveHasUsers') })
      } else {
        notify.error({ title: t('errors.remove') })
      }
    })
  }

  return [handleRequest, state]
}
